import vue from 'vue'
import { actionDelete } from '@/components/tools'
import modBox from '@/core/component/modBox'
import { sendMessage } from '@/assets/js/tools'
const that = vue.prototype
export default {
  className: 'applicationRecord',
  readonly: true,
  fields: [
    'name',
    'phone',
    'region',
    'storeName',
    'inStorePhotos',
    'panoramicPhotos',
    'businessType',
    'storeAddress',
    'permissionStatus'
  ],
  search: [
    'name',
    'permissionStatus'
  ],
  action: {
    delete: false,
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看申请详情',
      component: 'viewPage'
    },
    enter: {
      type: 'row',
      text: '开通',
      hidden ({ record, tags }) {
        if (record && (record.permissionStatus === 'opened' || record.permissionStatus === 'rejected')) return true
      },
      component: modBox,
      title: '选择账号类别',
      options: [
        {
          name: 'accountCategory',
          note: '账号类别',
          type: 'Select',
          items: {
            countyAccount: '代理账号',
            factoryAccount: '厂家账号',
            terminalAccount: '终端账号'
          }
        }
      ],
      modal: 'applicationRecord'
    },
    hasEnter: {
      type: 'row',
      text: '拒绝',
      hidden ({ record, tags }) {
        if (record && (record.permissionStatus === 'opened' || record.permissionStatus === 'rejected')) return true
      },
      callback: async ({ record, vm }) => {
        // 修改数据
        await vm.$modelAjax.put('applicationRecord', record.objectId, { permissionStatus: 'rejected' }).catch(() => {
          throw that.$notification['error']({
            message: '您授权该账号失败',
            description: '请重新尝试'
          })
        })
        // 短信通知用户授权状态
        await sendMessage([record.phone], '您账号申请的内容不符合我们的要求，暂时无法授权登录希望您能谅解！')
        that.$notification['success']({
          message: '您已拒绝授权该账号登录App',
          description: '权限状态修改成功'
        })
        vm.refresh()
      }
    },
    deleteRecord: {
      type: 'row',
      text: '删除',
      hidden ({ record, tags }) {
        if (record && (record.permissionStatus === 'pendingReview')) return true
      },
      callback: actionDelete
    }
  }
}
